import React, { useEffect } from 'react'
import isMobile from 'ismobilejs'

import { scroll } from '../../lib/utils'
import Footer from '../../sections/footer'
import WaveContainer from '../../components/wave-container'

import Faq from './components/faq'
import Hero from './components/hero'
import Intro from './components/intro'
import WhyFree from './components/why-free'
import SignupForm from './../free-start/components/signup-form'
import { Column, Row } from '../../components/layout-row'
import Testimonal from '../../components/testimonal'

import josefSkhayri from './testimonals-images/josefSkhayri.jpg'
import niclasAhden from './testimonals-images/niclasAhden.jpg'
import williamHollingworth from './testimonals-images/williamHollingworth.jpg'
import { FormattedHTMLMessage } from 'react-intl'

import styles from './landingPage.module.scss'
import Switchtodooer from './components/switchtodooer'
import Seo from '../../components/seo'

const LandingPage: React.FC = () => {
  const signupRef = React.createRef<HTMLDivElement>()

  useEffect(() => {
    if (window.location.search.includes('bankidsessionid')) {
      setTimeout(() => {
        scroll(signupRef)
      }, 1000)
    }
  }, [signupRef])

  const clientIsMobileOrTablet = isMobile().phone || isMobile().tablet

  return (
    <>
      <Seo
        description="Gratis bokföringsprogram som gör det enklare för dig att driva företag. Hantera enkelt bokföring, fakturering och löner på ett och samma ställe - helt online."
        image="https://www.dooer.com/images/og/og_yellow.jpg"
        title="Gratis bokföringsprogram online | Bokföring, fakturering och lön | Dooer"
        url="https://www.dooer.com"
      />

      <Hero cta={() => scroll(signupRef, 'start')} />
      <WaveContainer>
        <Intro />
      </WaveContainer>

      {/* TESTEMONIALS */}
      <div className={styles.textCenter}>
        <FormattedHTMLMessage
          defaultMessage="Företagarna som växer med Dooer"
          id="landingPage.testimonal.heading"
          tagName="h2"
        />
      </div>

      <Row alignItems="start" style={{ marginTop: '10rem' }}>
        <Column>
          <Testimonal
            imgSrc={josefSkhayri}
            jobTitle="Mincykelverkstad"
            name="Josef Skhayri"
            text={`Är grymt imponerad, hur kan allt det här vara gratis?
Det bästa är nog Dooer Fakturering, att kunna skicka fakturor via SMS
med betalinfo är väldigt smidigt.`}
            variant="large"
          />
        </Column>
        <Column>
          <Testimonal
            imgSrc={niclasAhden}
            jobTitle="Instateam"
            name="Niclas Åhdén"
            text="Dooer Fakturering är grymt, gillar starkt den automatiska avprickningen"
            variant="large"
          />
        </Column>
        <Column>
          <Testimonal
            imgSrc={williamHollingworth}
            jobTitle="Hollingworth Digital Consulting"
            name="William Hollingworth"
            text="Väldigt enkelt att skicka fakturor och följa upp. Extra smidigt är att betalda fakturor registreras automatiskt tack vare kopplingen till min bank."
            variant="large"
          />
        </Column>
      </Row>
      {/* END OF TESTEMONIALS */}

      <WaveContainer>
        <Switchtodooer />
      </WaveContainer>

      <div id="signup" ref={signupRef}>
        <SignupForm
          apps={['diyAccounting']}
          onAfterSubmit={() => {
            if (clientIsMobileOrTablet) {
              scroll(signupRef, 'start')
            }
          }}
        />
      </div>

      <WhyFree />

      <Faq />

      <Footer inverted />
    </>
  )
}

export default LandingPage
